export function createLogscordServerStructuredData(canonical, server) {
    return [
        {
            type: "application/ld+json",
            json: {
                "@context": "https://schema.org",
                "@type": "ProfilePage",
                url: canonical,
                name: server.name,
                mainEntity: {
                    "@type": "Organization",
                    identifier: server.guildId,
                    name: server.name,
                    description: server.description ?? undefined,
                    image: server.avatarUrl ?? undefined,
                    url: canonical,
                },
            },
        },
    ];
}
//# sourceMappingURL=server.js.map